import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI, URL_EXTENSION } from '../utility/config'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import fi from 'date-fns/locale/fi' // the locale you want

function CreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    window.location.href = `${URL_EXTENSION}calendars`
  }, 1100)
  return (
    <div>
      <h2 className='message_title'>Lisäys onnistui</h2>
    </div>
  )
}

function AddExclusionTimePopup(props) {
  const [show, setShow] = useState(false)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState(null)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    startTime: '',
    endTime: '',
    description: '',
  })

  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  const onChangeforms = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e, startDate, endDate) => {
    e.preventDefault()
    let dates = []
    let AllDateTimes = []
    let DayStart = '00:00:00'
    let DayEnd = '23:59:59'

    if (endDate === null && startDate === null) {
      console.log('date_error')
    } else if (endDate === null) {
      console.log('date_error')
    } else {
      //to avoid modifying the original date
      const theDate = new Date(startDate)
      while (theDate < endDate) {
        dates = [
          ...dates,
          { shiftDate: moment(new Date(theDate)).format('YYYY-MM-DD') },
        ]
        theDate.setDate(theDate.getDate() + 1)
      }
      dates = [
        ...dates,
        { shiftDate: moment(new Date(endDate)).format('YYYY-MM-DD') },
      ]

      if (dates.length === 1) {
        var momentObjStartOne = moment(
          dates[0].shiftDate + formData.startTime,
          'YYYY-MM-DDLT'
        )
        var momentObjEndOne = moment(
          dates[0].shiftDate + formData.endTime,
          'YYYY-MM-DDLT'
        )
        // conversion
        var dateTimeStartOne = momentObjStartOne.format('YYYY-MM-DDTHH:mm')
        var dateTimeEndOne = momentObjEndOne.format('YYYY-MM-DDTHH:mm')

        let oneDate = {
          startTime: new Date(Date.parse(dateTimeStartOne)).toString(),
          endTime: new Date(Date.parse(dateTimeEndOne)).toString(),
          description: formData.description,
        }
        setLoading(true)
        try {
          await axios.post(`${SERVER_URI}/add_order_exclusion_time/`, oneDate, {
            headers: { Authorization: `Token ${userToken}` },
          })
        } catch (e) {
          console.log('Error in adding shift', e)
        }
        window.setTimeout(function () {
          // Move to a new location
          setLoading(false)
          setShow(!show)
        }, 1400)
      } else {
        var firstDate = dates[0].shiftDate
        var lastDate = dates[dates.length - 1].shiftDate
        dates.pop()
        dates.shift()

        for (let u = 0; u < dates.length; u++) {
          var momentObjStart = moment(
            dates[u].shiftDate + DayStart,
            'YYYY-MM-DDLT'
          )
          var momentObjEnd = moment(dates[u].shiftDate + DayEnd, 'YYYY-MM-DDLT')
          // conversion
          var dateTimeStart = momentObjStart.format('YYYY-MM-DDTHH:mm')
          var dateTimeEnd = momentObjEnd.format('YYYY-MM-DDTHH:mm')
          let DateTimeData = {
            startTime: dateTimeStart,
            endTime: dateTimeEnd,
            description: formData.description,
          }
          AllDateTimes.push(DateTimeData)
        }

        // add last and first date back into the array
        var momentObjFirstStart = moment(
          firstDate + formData.startTime,
          'YYYY-MM-DDLT'
        )
        var momentObjFirstEnd = moment(firstDate + DayEnd, 'YYYY-MM-DDLT')

        var momentObjLastStart = moment(lastDate + DayStart, 'YYYY-MM-DDLT')
        var momentObjLastEnd = moment(
          lastDate + formData.endTime,
          'YYYY-MM-DDLT'
        )

        // conversion
        var firstDateStart = momentObjFirstStart.format('YYYY-MM-DDTHH:mm')
        var firstDateEnd = momentObjFirstEnd.format('YYYY-MM-DDTHH:mm')

        var lastDateStart = momentObjLastStart.format('YYYY-MM-DDTHH:mm')
        var lastDateEnd = momentObjLastEnd.format('YYYY-MM-DDTHH:mm')

        let FirstTimeData = {
          startTime: firstDateStart,
          endTime: firstDateEnd,
          description: formData.description,
        }
        let LastDateTimeData = {
          startTime: lastDateStart,
          endTime: lastDateEnd,
          description: formData.description,
        }
        AllDateTimes.push(LastDateTimeData)
        AllDateTimes.unshift(FirstTimeData)
      }

      for (let n = 0; n < AllDateTimes.length; n++) {
        let start = AllDateTimes[n].startTime
        let end = AllDateTimes[n].endTime
        let data = {
          startTime: new Date(Date.parse(start)).toString(),
          endTime: new Date(Date.parse(end)).toString(),
          description: AllDateTimes[n].description,
        }
        setLoading(true)
        try {
          await axios.post(`${SERVER_URI}/add_order_exclusion_time/`, data, {
            headers: { Authorization: `Token ${userToken}` },
          })
        } catch (e) {
          console.log('Error in adding shift', e)
        }
      }
      window.setTimeout(function () {
        // Move to a new location
        setLoading(false)
        setShow(!show)
      }, 1400)
    }
  }
  return (
    <div>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <div className={loading === true ? 'loading' : 'notloading'}>
                Lisätään poikkeusaikoja
              </div>
              <h2 className='popUp_title'>Lisää poikkeusajan päivämäärä(t)</h2>
              <form
                className='exclusionTime_form'
                onSubmit={(e) => doSubmit(e, startDate, endDate)}
              >
                <label className='label_add' htmlFor='startDate'>
                  Aloituspäivä:
                </label>
                <DatePicker
                  required
                  dateFormat='dd.MM.yyyy'
                  closeOnScroll={true}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  placeholderText='Aloituspäivä'
                  locale={fi}
                />
                <br />
                <label className='label_add' htmlFor='endDate'>
                  Lopetuspäivä:
                </label>
                <DatePicker
                  required
                  dateFormat='dd.MM.yyyy'
                  locale={fi}
                  closeOnScroll={true}
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  placeholderText='Lopetuspäivä'
                />
                <br />

                <label className='label_add' htmlFor='startTime'>
                  Valitse aloitusaika:
                </label>
                <input
                  type='time'
                  id='startTime'
                  name='startTime'
                  min='00:01'
                  max='23:59'
                  onChange={onChangeforms}
                  required
                ></input>
                <br />

                <label className='label_add' htmlFor='endTime'>
                  Valitse lopetusaika:
                </label>
                <input
                  type='time'
                  id='endTime'
                  name='endTime'
                  onChange={onChangeforms}
                  required
                ></input>
                <br />
                <label className='label_add' htmlFor='description'>
                  Kuvaus:
                </label>
                <br />
                <textarea
                  id='description'
                  name='description'
                  rows='4'
                  cols='35'
                  onChange={onChangeforms}
                  required
                ></textarea>
                <br />
                <input
                  type='submit'
                  id='gradient_Button'
                  value='Lisää poikkeusaika'
                />
              </form>
            </div>
          )}
          {show && <CreatedMessage />}
        </div>
      </div>
    </div>
  )
}

export default AddExclusionTimePopup
